import axios from "axios";
import Session from "supertokens-auth-react/recipe/session";

// Create Axios instance
const API_BASE_URL = process.env.REACT_APP_API_DOMAIN || (process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_LOCAL_API_DOMAIN
  : "https://api.yourshirt.co");

console.log("API_BASE_URL being used by apiClient:", API_BASE_URL);

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,  // This enables cookie-based authentication!
  timeout: 180000, // Increase timeout to 180 seconds (3 minutes)
});


export const getProductsCatalog = async () => {
  const response = await api.get('/products-catalog');
  return response.data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/upload-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const createMockupTask = async (mockupData) => {
  const response = await api.post('/create-mockup', mockupData, {
    validateStatus: (status) => {
      return (status >= 200 && status < 300) || status === 202;
    },
  });
  return response;
};

export const getMockup = async (orderId) => {
  const response = await api.get(`/get-mockup/order/${orderId}`);
  return response.data;
};

export const deleteImage = async (imageId) => {
  const response = await api.delete(`/images/${imageId}`);
  return response.data;
};

export const getProductDetails = async (productId) => {
  const response = await api.get(`/products/${productId}/details`);
  return response.data;
};

export const confirmPrintfulOrder = async (orderId) => {
  const response = await api.post(`/confirm-order/${orderId}`);
  return response.data;
};

export const getPrintfulOrderStatus = async (orderId) => {
  const response = await api.get(`/orders/${orderId}/status`);
  return response.data;
};

export const getOrders = async () => {
  const response = await api.get('/orders');
  return response.data;
};

export const getSingleOrder = async (orderId) => {
  const response = await api.get(`/orders/${orderId}`);
  return response.data;
};



export const removeBackgroundImage = async (imageId) => {
  const response = await api.post(`/images/${imageId}/remove-background`);
  return response.data;
};

export const createPaymentIntent = async (paymentData) => {
  console.log("Sending payment intent data to backend:", paymentData);
  const response = await api.post('/create-payment-intent', paymentData);
  console.log("Received payment intent response from backend:", response.data);
  return response.data;
};